import { createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import { EventAccommodationRoomTypeService } from "Bands/services/EventAccommodationRoomTypeService";

import { BAND_ACTIONS, IAccommodationRoomTypeParams } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const createAccommodationRoomType = createAsyncThunk(
  BAND_ACTIONS.createAccommodationRoomType,
  async (block: IAccommodationRoomTypeParams, { rejectWithValue }) => {
    try {
      const createdItem =
        await EventAccommodationRoomTypeService.createAccommodationRoomType(
          block
        );
      const id = Object.values(createdItem?.eventAccommodationRoomType)?.[0]
        ?.attributes?.id;

      return { id, createdItem };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const dispatchGetEventAccommodationRoomTypes = (
  dispatch: Dispatch<any>,
  blockId: string
) => {
  const action =
    API_ENDPOINTS.EVENT_ACCOMMODATION_ROOM_TYPES_FOR_BLOCK(blockId);
  return dispatch(getEventAccommodationRoomTypes({ blockId, action }));
};

export const getEventAccommodationRoomTypes = createAsyncThunk(
  BAND_ACTIONS.getEventAccommodationRoomTypes,
  async (
    { blockId }: { blockId: string; action: string },
    { rejectWithValue }
  ) => {
    try {
      const rooms =
        await EventAccommodationRoomTypeService.getEventAccommodationRoomTypes(
          blockId
        );
      return rooms;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteAccommodationRoomType = createAsyncThunk(
  BAND_ACTIONS.deleteAccommodationRoomType,
  async (
    { id, blockId }: { id: string; blockId: string },
    { rejectWithValue, dispatch }
  ) => {
    try {
      await EventAccommodationRoomTypeService.deleteAccommodationRoomType(id);

      dispatchGetEventAccommodationRoomTypes(dispatch, blockId);

      return {
        path: API_ENDPOINTS.EVENT_ACCOMMODATION_ROOM_TYPE(id),
        dataKey: IDataKeys.eventAccommodationRoomType,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editEventAccommodationRoomType = createAsyncThunk(
  BAND_ACTIONS.editAccommodationRoomType,
  async (
    props: { id: string; data: IAccommodationRoomTypeParams },
    { rejectWithValue }
  ) => {
    try {
      const data =
        await EventAccommodationRoomTypeService.editAccommodationRoomType(
          props
        );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
